/**
 * Creates a BroadcastChannel
 * https://developer.mozilla.org/en-US/docs/Web/API/Broadcast_Channel_API
 */
export default new BroadcastChannel('sifflet-data');
